/*
  *******************
  Grutto ©2020
  *******************
*/
import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom';
//import {Route, Router} from 'react-router-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './init/App';
import './init/i18n';
import './assets/scss/styles.scss';

ReactDOM.render(
    <Router><App /></Router>,
    document.getElementById('root')
);


